import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import {Usuario, Perfil} from '../../model/usuario';
import {Parametro} from '../../model/parametro';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {AlertaService} from 'src/app/util/alerta.service';
import {IntranetService} from '../../intranet.service';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {functionHelper, functionUtil} from 'src/app/util/functionConst';
import {Router} from '@angular/router';

@Component({
  selector: 'sura-acceso',
  templateUrl: './acceso.component.html',
  styleUrls: ['./acceso.component.scss']
})
export class AccesoComponent implements OnInit {
  public accesoForm: UntypedFormGroup;
  public linkActive = 'ACCESO';
  usuario: Usuario = new Usuario;
  listPerfil: Perfil[] = [];
  listEstado: Parametro[] = [];
  listTipoDocumento: Parametro[] = [];
  // modo: string = "A";//agregar y editar
  disableBtnCancel = true;
  disableBtnAgregar = false;
  disableBtnEditar = true;
  disableBtnSearch = false;
  disableBtnSearchDatosPersonales = true;
  disableBtnGuardar = true;
  modoActivo = '';
  fnInputMaxLength = functionUtil.fnInputMaxLength;
  fnKeyDownAlphaNumeric = functionUtil.fnKeyDownAlphaNumeric;
  fnAlphaNumericMobile = functionUtil.fnAlphaNumericMobile;
  @ViewChild('usuario', {static: false}) fieldUsuario: ElementRef;
  @ViewChild('nombres', {static: false}) fieldNombres: ElementRef;

  constructor(private intranetService: IntranetService,
              private alertaService: AlertaService,
              private router: Router) {
    this.linkActive = this.router.url;
  }

  ngOnInit() {
    this.accesoForm = new UntypedFormGroup({
      idUsuario: new UntypedFormControl(''),
      idPersona: new UntypedFormControl(''),
      idPerfilUsuario: new UntypedFormControl(''),
      usuario: new UntypedFormControl('', [Validators.maxLength(13), Validators.required]),
      tipoDocumento: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      nroDocumento: new UntypedFormControl({
        value: null,
        disabled: true
      }, [Validators.maxLength(13), Validators.required, Validators.minLength(8)]),
      nombres: new UntypedFormControl({value: null, disabled: true}, [Validators.maxLength(100), Validators.required]),
      apellidos: new UntypedFormControl({value: null, disabled: true}, [Validators.maxLength(100), Validators.required]),
      correo: new UntypedFormControl({
        value: null,
        disabled: true
      }, [Validators.maxLength(50), Validators.pattern(ParametrosConst.REG_EXP_EMAIL), Validators.required]),
      perfil: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
      estado: new UntypedFormControl({value: null, disabled: true}, [Validators.required]),
    });
    this.cargarCombos();
  }

  cargarCombos() {
    this.intranetService.listarPerfiles().then(resultado => {
      if (resultado instanceof Array) {
        this.listPerfil = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
    this.intranetService.obtenerParametro(ParametrosConst.ESTADOS_USUARIO).then(resultado => {
      if (resultado instanceof Array) {
        this.listEstado = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
    this.intranetService.obtenerParametro(ParametrosConst.TIPO_DOCUMENTO).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoDocumento = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  buscarUsuario() {
    this.obtenerDatosUsuario();
    this.disableBtnSearchDatosPersonales = true;
    this.desHabilitarCampos();
    this.desHabilitarCamposDatosPersonales();
  }

  obtenerDatosUsuario() {
    // const usuario: Usuario;
    this.intranetService.obtenerAcceso(this.accesoForm.controls['usuario'].value).then((result: any) => {
      this.alertaService.success(result);
      this.accesoForm.controls.idUsuario.setValue(result.idUsuario);
      this.accesoForm.controls.idPersona.setValue(result.idPersona);
      this.accesoForm.controls.estado.setValue(result.estado);
      this.accesoForm.controls.idPerfilUsuario.setValue(result.idPerfilUsuario);
      this.accesoForm.controls.perfil.setValue(result.idPerfilUsuario);
      this.accesoForm.controls.tipoDocumento.setValue(result.tipoDocumento);
      this.accesoForm.controls.nroDocumento.setValue(result.numeroDocumento);
      this.accesoForm.controls.nombres.setValue(result.nombres);
      this.accesoForm.controls.apellidos.setValue(result.apellidos);
      this.accesoForm.controls.correo.setValue(result.correo);

      this.disableBtnAgregar = true;
      this.disableBtnEditar = false;
      this.disableBtnCancel = false;
      this.disableBtnSearch = true;
      this.modoActivo = ParametrosConst.CODIGO_ACTION_BUSCAR;
      // FALTA
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  agregarUsuario() {
    this.disableBtnAgregar = true;
    this.disableBtnCancel = false;
    this.fieldUsuario.nativeElement.focus();
    this.habilitarCampos(ParametrosConst.CODIGO_ACTION_AGREGAR);
    this.disableBtnSearchDatosPersonales = false;
    this.disableBtnGuardar = false;
    this.disableBtnSearch = true;
    this.accesoForm.controls.estado.setValue(ParametrosConst.ESTADO_USUARIO_ACTIVO);
    this.accesoForm.controls.estado.disable();
  }

  editarUsuario() {
    this.fieldUsuario.nativeElement.focus();
    this.habilitarCampos(ParametrosConst.CODIGO_ACTION_EDITAR);
    this.disableBtnSearchDatosPersonales = true;
    this.disableBtnGuardar = false;
    this.disableBtnEditar = true;
  }

  habilitarCampos(_modo: string) {
    this.modoActivo = _modo;
    this.accesoForm.controls.tipoDocumento.enable();
    this.accesoForm.controls.nroDocumento.enable();
    this.accesoForm.controls.perfil.enable();
    this.accesoForm.controls.estado.enable();
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
      this.habilitarCamposDatosPersonales();
    }
  }

  desHabilitarCampos() {
    this.accesoForm.controls.tipoDocumento.disable();
    this.accesoForm.controls.nroDocumento.disable();
    this.accesoForm.controls.perfil.disable();
    this.accesoForm.controls.estado.disable();
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
      this.desHabilitarCamposDatosPersonales();
    }
  }

  habilitarCamposDatosPersonales() {
    this.accesoForm.controls.nombres.enable();
    this.accesoForm.controls.apellidos.enable();
    this.accesoForm.controls.correo.enable();
  }

  desHabilitarCamposDatosPersonales() {
    this.accesoForm.controls.nombres.disable();
    this.accesoForm.controls.apellidos.disable();
    this.accesoForm.controls.correo.disable();
  }

  cancelarOperacion() {
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR ||
      this.modoActivo === ParametrosConst.CODIGO_ACTION_BUSCAR) {
      this.disableBtnSearchDatosPersonales = true;
      this.limpiarCampos();
      if (this.modoActivo === ParametrosConst.CODIGO_ACTION_BUSCAR) {
        this.disableBtnEditar = true;
      }
      this.accesoForm.controls.estado.enable();
    } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
      this.disableBtnEditar = true;
      this.limpiarCampos();
    }
    this.disableBtnAgregar = false;
    this.accesoForm.controls.perfil.disable();
    this.accesoForm.controls.estado.disable();
    this.accesoForm.controls.tipoDocumento.disable();
    this.accesoForm.controls.nroDocumento.disable();
    this.desHabilitarCamposDatosPersonales();
    this.disableBtnSearch = false;
    this.disableBtnCancel = true;
    this.fieldUsuario.nativeElement.focus();
  }

  limpiarCampos() {
    this.accesoForm.reset();
  }

  hasError(controlName: string) {
    return this.accesoForm.controls[controlName].invalid;
  }

  obtenerMensajeError(controlName: string) {
    return functionHelper.extraerErrorGroup(this.accesoForm, controlName);
  }

  buscarPersona() {
    const tipoDocumento = this.accesoForm.controls.tipoDocumento.value;
    const numeroDocumento = this.accesoForm.controls.nroDocumento.value;
    this.accesoForm.controls.nombres.reset();
    this.accesoForm.controls.apellidos.reset();
    this.accesoForm.controls.correo.reset();
    this.intranetService.buscarPersona(tipoDocumento, numeroDocumento).then((respuesta: any) => {
      this.accesoForm.controls.idPersona.setValue(respuesta.idPersona);
      this.accesoForm.controls.nombres.setValue(respuesta.nombres);
      this.accesoForm.controls.apellidos.setValue(respuesta.apellidos);
      this.accesoForm.controls.correo.setValue(respuesta.correo);
    }).catch(error => {
      this.alertaService.error(error);
    });
    this.habilitarCamposDatosPersonales();
    this.fieldNombres.nativeElement.focus();
    this.disableBtnGuardar = false;
  }

  guardarAcceso() {
    try {
      if (this.accesoForm.invalid) {
        return false;
      }
      const objUsuario: any = this.accesoForm.getRawValue();
      const userSave = {};

      userSave['tipoDocumento'] = objUsuario.tipoDocumento;
      userSave['numeroDocumento'] = objUsuario.nroDocumento;
      userSave['nombres'] = objUsuario.nombres;
      userSave['apellidos'] = objUsuario.apellidos;
      userSave['correo'] = objUsuario.correo;
      userSave['estado'] = objUsuario.estado;
      userSave['usuarioRegistro'] = 'ROOT';
      userSave['usuario'] = objUsuario.usuario;

      if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR) {
        userSave['idPerfil'] = objUsuario.perfil;
        this.intranetService.guardarAcceso(userSave).then(respuesta => {
          this.accesoForm.controls.usuario.setValue(userSave['usuario']);
          this.buscarUsuario();
          this.alertaService.success(respuesta);
        }).catch(error => {
          this.alertaService.error(error);
        });
      } else if (this.modoActivo === ParametrosConst.CODIGO_ACTION_EDITAR) {
        userSave['idUsuario'] = objUsuario.idUsuario;
        userSave['idPersona'] = objUsuario.idPersona;
        userSave['nombre'] = objUsuario.usuario;
        userSave['idPerfilUsuario'] = objUsuario.idPerfilUsuario;
        userSave['idPerfilUsuarioNew'] = objUsuario.perfil;
        this.intranetService.editarAcceso(userSave).then(respuesta => {
          this.accesoForm.controls.usuario.setValue(userSave['usuario']);
          this.buscarUsuario();
          this.alertaService.success(respuesta);
        }).catch(error => {
          this.alertaService.error(error);
        });
      }
    } catch (error) {
      this.alertaService.error(error);
    }
  }

  desactivarBtnGuardar() {
    return this.disableBtnGuardar || (this.accesoForm.invalid && !this.disableBtnGuardar);
  }

  changeNroDocumento() {
    if (this.modoActivo === ParametrosConst.CODIGO_ACTION_AGREGAR) {
      this.desHabilitarCamposDatosPersonales();
      this.accesoForm.controls.nombres.reset();
      this.accesoForm.controls.apellidos.reset();
      this.accesoForm.controls.correo.reset();
      this.disableBtnGuardar = true;
    }
  }
}
